(function () {

var $f3e651bd9531efc4$export$2e2bcd8739ae039 = ()=>{
    const polsatCont = document.getElementById("js-polsat-history");
    if (polsatCont) {
        const scrollItems = polsatCont.querySelector(".tv-program");
        const activeItem = scrollItems.querySelector(".swiper-pagination-bullet-active").parentElement;
        if (window.innerWidth > 768) scrollItems.scroll({
            top: activeItem.offsetTop - 20,
            behavior: "smooth"
        });
        else scrollItems.scroll({
            left: activeItem.offsetLeft,
            behavior: "smooth"
        });
    }
};


var $40873ecf3c18e122$export$2e2bcd8739ae039 = ()=>{
    const modal = document.querySelector(".modal");
    if (modal) {
        const body = document.body;
        const closeModalButtons = modal.querySelectorAll(".close");
        const openModal = ()=>{
            modal.classList.add("visible");
            body.classList.add("overflow-hidden");
            if (modal.hasAttribute("data-blur")) body.classList.add("is-modal-blur");
        };
        const closeModal = ()=>{
            modal.classList.remove("visible");
            body.classList.remove("overflow-hidden");
            if (modal.hasAttribute("data-blur")) body.classList.remove("is-modal-blur");
        };
        closeModalButtons.forEach((closeBtn)=>{
            closeBtn.addEventListener("click", closeModal);
        });
        openModal();
    }
};


window.addEventListener("DOMContentLoaded", ()=>{
    (0, $f3e651bd9531efc4$export$2e2bcd8739ae039)();
    (0, $40873ecf3c18e122$export$2e2bcd8739ae039)();
});

})();
//# sourceMappingURL=index.js.map
